import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-116593d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "test-instructions-StepOne-component" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "img-container w-100 d-flex justify-content-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "img-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_alert_box = _resolveComponent("alert-box")!
  const _component_floating_card = _resolveComponent("floating-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_floating_card, {
      ref: "base-modal",
      stepNumber: "1",
      stepTitle: this.StepContent.title,
      nextButtonActive: "",
      onNextStep: _cache[0] || (_cache[0] = ($event: any) => (this.$emit('nextStep'))),
      onPreviousStep: _cache[1] || (_cache[1] = ($event: any) => (this.$emit('previousStep')))
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", {
          class: "steps-info open-sans-font",
          innerHTML: _ctx.StepContent.steps
        }, null, 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            class: "colect-image",
            src: _ctx.imagePath,
            alt: ""
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.StepContent.warningActive)
            ? (_openBlock(), _createBlock(_component_alert_box, {
                key: 0,
                alert: "",
                stepContent: _ctx.StepContent
              }, null, 8, ["stepContent"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["stepTitle"])
  ]))
}